import activeOrder from "./components/active-orders/index.vue";
import archiveOrder from "./components/archive-orders/index.vue";
import profileFavorite from "../favourite/index.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
    GET_MORE_ACTIVE_ORDER_LIST,
    GET_NEXR_ACTIVE_ORDER_LIST,
    GET_NEXT_ACTIVE_ORDER_LIST
} from "../../../../store/action-types";

export default {
    name: "orders",
    data() {
        return {
            activeOrders: true,
            archiveOrders: false,
            favoriteItems: false,
            currentPage: 1,
        };
    },
    components: {
        activeOrder,
        archiveOrder,
        profileFavorite,
    },
    created() {
        this.fetchActiveOrderList();
        this.fetchArchiveOrderList();
        // this.fetchUserData();
        // setTimeout(()=>{
        //   console.log(this.archiveOrderList);
        // },500)
    },
    watch: {
        showFavoritePage() {
            this.favoriteItems = true;
            this.activeOrders = false;
            this.archiveOrders = false;
            this.isShowFavoritePage(false);
        },
    },
    mounted() {
        if (this.$route.name === "profile-favourite") {
            this.favoriteItems = true;
            this.activeOrders = false;
        }
    },
    computed: {
        ...mapGetters({
            archiveOrderList: "profile/archiveOrderList",
            archiveOrderListLength: "profile/archiveOrderListLength",
            archiveOrderListLoading: "profile/archiveOrderListLoading",
            //
            activeOrderList: "profile/activeOrderList",
            activeOrderListLength: "profile/activeOrderListLength",
            activeOrderListLoading: "profile/activeOrderListLoading",
            activeOrderHasNextPage: "profile/activeOrderHasNextPage",
            showFavoritePage: "system/showFavoritePage",
            //
            user: "profile/user",
        }),
    },
    methods: {
        ...mapActions({
            fetchUserData: `profile/FETCH_USER_DATA`,
            fetchArchiveOrderList: `profile/GET_ARCHIVE_ORDER_LIST`,
            fetchActiveOrderList: `profile/GET_ACTIVE_ORDER_LIST`,
            getNextActiveOrderList: `profile/GET_NEXT_ACTIVE_ORDER_LIST`,
        }),
        ...mapMutations({
            isShowFavoritePage: "system/SET_FAVORITE_PAGE",
        }),
        loadMoreActive() {
            this.currentPage++;
            this.getNextActiveOrderList(this.currentPage)
        },
        changeTab(current) {
            this.activeOrders = this.archiveOrders = this.favoriteItems = false;
            if (current === "activeOrders") {
                this.activeOrders = true;
            } else if (current === "archiveOrders") {
                this.archiveOrders = true;
            } else {
                this.favoriteItems = true;
            }
        },
    },
};
